import React, { useEffect, useState } from 'react';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    scrollTopBtn: {
        position: 'fixed',
        bottom: theme.spacing(3),
        right: theme.spacing(3),
        zIndex: 1300,
        background: 'rgba(255,255,255)',
        color: '#333',
        border: '1px solid #e0e0e0',
        borderRadius: '50%',
        width: 36,
        height: 36,
        minWidth: 0,
        minHeight: 0,
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        cursor: 'pointer',
        transition: 'opacity 0.2s, background 0.2s',
        opacity: 0.7,
        '&:hover': {
            opacity: 1,
            background: 'rgba(255,255,255,0.95)',
        },
    },
    hide: {
        display: 'none',
    },
}));

const ScrollToTopButton = () => {
    const classes = useStyles();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setVisible(window.pageYOffset > 200);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <button
            className={visible ? classes.scrollTopBtn : `${classes.scrollTopBtn} ${classes.hide}`}
            onClick={handleClick}
            aria-label="Scroll to top"
        >
            <KeyboardArrowUpIcon fontSize="small" style={{ color: '#333' }} />
        </button>
    );
};

export default ScrollToTopButton;
